export const DateInputType = {
    dateLengthLimitForError: 6,
    formattedDateMaxLength: 10,
    dateRangeLength: 2,
    startDateLength: 8,
};
